"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inferMarks = void 0;
var translate2d_1 = require("../../common/translate2d");
var getSf_1 = require("../../common/getSf");
var inferMarks = function (srcPlane, destPlane, density, forceInteger) {
    if (density === void 0) { density = 3; }
    if (forceInteger === void 0) { forceInteger = false; }
    var _a = [srcPlane[1][0][1], srcPlane[1][1][1]], src_min = _a[0], src_max = _a[1];
    var step = getSf_1.getSf(Math.round((src_max - src_min) / density * 100) / 100, forceInteger);
    if (step === 0)
        step = 1;
    var marks = [];
    if (step > 0) {
        for (var i = src_min === 0 ? 0 : step; i <= src_max; i += step) {
            marks.push(Math.round(i * 100) / 100);
        }
    }
    else {
        marks.push(Math.round(src_min * 100) / 100);
    }
    var visibleMarks = marks.filter(function (it) { return it >= src_min && it <= src_max; });
    var markers = visibleMarks.map(function (it) {
        return [
            it,
            Math.floor(translate2d_1.translate2d([0, it], srcPlane, destPlane)[1])
        ];
    });
    return markers;
};
exports.inferMarks = inferMarks;
